/*
 * Copyright (c) 2024. World Wide Generation Ltd
 */

import { QuestionData } from '../../utils';
import React, { useContext, useMemo } from 'react';
import { SelectFactory, SelectTypes } from '@g17eco/molecules/select/SelectFactory';
import { CustomDashboardContext } from '../../context/CustomDashboardWrapper';
import { ProviderQuestionSelection } from './ProviderQuestionSelection';
import { emptyUtrData } from '@features/custom-dashboard/utils/dashboard-utils';

interface Props {
  questionData: QuestionData;
  changeQuestionData: (questionData: QuestionData) => void;
}

export const IntegrationSourceSelector = ({ questionData, changeQuestionData }: Props) => {
  const { integrationProviders } = useContext(CustomDashboardContext);

  const options = useMemo(() => {
    return (
      integrationProviders?.map((provider) => ({
        value: provider.code,
        searchString: provider.name,
        label: (
          <span>
            <img src={provider.icon ?? provider.logo} width={26} height={26} alt={provider.name} className='me-2' />
            <span>{provider.name}</span>
          </span>
        ),
        questions: provider.questions,
      })) ?? []
    );
  }, [integrationProviders]);

  const selectedOption = options.find((o) => o.value === questionData.integrationCode) ?? null;

  return (
    <>
      <p className='mt-3 text-medium'>Select Integration</p>
      <SelectFactory
        selectType={SelectTypes.SingleSelect}
        placeholder='Select Integration'
        options={options}
        value={selectedOption}
        onChange={(option) =>
          changeQuestionData({
            ...emptyUtrData,
            integrationCode: option?.value ?? '',
          })
        }
      />
      {selectedOption ? (
        <ProviderQuestionSelection
          onChange={(option) => changeQuestionData({ ...questionData, ...option })}
          questionData={questionData}
          questions={selectedOption.questions}
        />
      ) : null}
    </>
  );
};
